import { ReferralCodeInfo } from "@mezo/api"

import { MAX_NUMBER_OF_REFERRAL_CODES } from "#/shared/constants"
import {
  getTotalDepositsAmount,
  isTokenEligibleForUnlocks,
} from "#/shared/utils"

import createDappAsyncThunk from "../asyncThunk"
import { setReferralCodes } from "../slices/referrals"

export const fetchReferralCode = createDappAsyncThunk(
  "account/fetchReferralCode",
  async (
    code: string,
    { extra: { sdk } },
  ): Promise<ReferralCodeInfo | null> => {
    const referralCode = await sdk.mezo.api.referralCodes.getReferralCode(code)
    return referralCode
  },
)

export const fetchAccountReferralCodeData = createDappAsyncThunk(
  "referrals/fetchAccountReferralCodeData",
  async (_, { getState, dispatch, extra: { sdk } }) => {
    const referralCodes =
      await sdk.mezo.api.referralCodes.getAccountReferralCodeData()

    if (referralCodes.length >= MAX_NUMBER_OF_REFERRAL_CODES) {
      dispatch(setReferralCodes(referralCodes))
      return
    }

    const eligibleDeposits = getState().portal.deposits.filter(({ token }) =>
      isTokenEligibleForUnlocks(token),
    )

    const sumOfDeposits = getTotalDepositsAmount(eligibleDeposits)

    if (sumOfDeposits === 0n) {
      dispatch(setReferralCodes(referralCodes))
      return
    }

    const { codes } = await sdk.mezo.api.referralCodes.generateReferralCodes()

    if (!codes.length) return

    dispatch(setReferralCodes(codes))
  },
)
